const regionNameFormatterCache = new Map();

export function isZhLocale(locale = '') {
  return String(locale || '').toLowerCase().startsWith('zh');
}

function getRegionNameFormatter(locale) {
  const cacheKey = isZhLocale(locale) ? 'zh-CN' : 'en-US';
  if (!regionNameFormatterCache.has(cacheKey)) {
    try {
      regionNameFormatterCache.set(cacheKey, new Intl.DisplayNames([cacheKey], {
        type: 'region'
      }));
    } catch (error) {
      regionNameFormatterCache.set(cacheKey, null);
    }
  }
  return regionNameFormatterCache.get(cacheKey);
}

function getRegionDisplayName(code, locale) {
  const formatter = getRegionNameFormatter(locale);
  const currentCode = String(code || '').trim().toUpperCase();
  if (!formatter || !currentCode) {
    return '';
  }

  try {
    return String(formatter.of(currentCode) || '').trim();
  } catch (error) {
    return '';
  }
}

export function getLocalizedAreaName(item = {}, locale = '') {
  if (isZhLocale(locale)) {
    return item?.nameCn
      || getRegionDisplayName(item?.iso_code_2, 'zh-CN')
      || item?.name
      || item?.nameEn
      || '';
  }
  return item?.nameEn
    || getRegionDisplayName(item?.iso_code_2, 'en-US')
    || item?.name
    || item?.nameCn
    || '';
}

export function getLocalizedCountryCodeName(item = {}, locale = '') {
  if (isZhLocale(locale)) {
    return item?.nameCn || getRegionDisplayName(item?.code, 'zh-CN') || item?.name || item?.nameEn || '';
  }
  return item?.nameEn || getRegionDisplayName(item?.code, 'en-US') || item?.name || item?.nameCn || '';
}
